<template>
  <div class="space-y-5 p-4">
    <p class="rounded-xl bg-[#1c4848]/[0.04] p-3 text-xs leading-relaxed text-[#1c4848]/70">Tip: type <kbd class="rounded bg-white px-1 font-bold ring-1 ring-[#1c4848]/10">/</kbd> on an empty line to add any of these while you write.</p>
    <section v-for="group in COMPONENT_GROUPS" :key="group">
      <h3 class="mb-2 text-[10px] font-bold uppercase tracking-widest text-[#1c4848]/45">{{ group }}</h3>
      <div class="grid grid-cols-2 gap-2">
        <button
          v-for="component in COMPONENTS.filter((c) => c.group === group)"
          :key="component.key"
          type="button"
          class="flex min-h-[72px] flex-col items-start gap-1 rounded-xl border border-[#1c4848]/10 bg-white p-2.5 text-left transition-colors hover:border-[#1c4848]/30 hover:bg-[#1c4848]/[0.03] disabled:opacity-40"
          :disabled="readOnly"
          :title="component.hint"
          @click="insertComponent(editor, component)"
        >
          <iconify-icon :icon="component.icon" class="text-lg text-[#1c4848]" aria-hidden="true" />
          <span class="text-[11px] font-bold leading-tight text-[#1c4848]">{{ component.label }}</span>
        </button>
      </div>
    </section>
    <button type="button" class="min-h-11 w-full rounded-xl border border-[#1c4848]/10 text-xs font-bold text-[#1c4848]/70 hover:bg-[#1c4848]/5 disabled:opacity-40" :disabled="readOnly" @click="importOpen = !importOpen">Import JSON</button>
    <form v-if="importOpen" class="space-y-2" @submit.prevent="importJson">
      <textarea v-model="importRaw" rows="6" spellcheck="false" aria-label="Page blocks as JSON" placeholder='[{"type":"text","content":{"value":"..."}}]' class="w-full resize-y rounded-xl border border-[#1c4848]/10 p-2 font-mono text-[11px] text-[#1c4848] outline-none focus:border-[#1c4848]/30"></textarea>
      <p v-if="importError" role="alert" class="text-xs text-red-700">{{ importError }}</p>
      <button type="submit" class="min-h-9 w-full rounded-lg bg-[#1c4848] text-xs font-bold text-white">Add to the page</button>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { COMPONENTS, COMPONENT_GROUPS, insertComponent, nodesFromLegacyJson } from '@/components/writer/catalog.js';

const props = defineProps({
  editor: { type: Object, required: true },
  readOnly: { type: Boolean, default: false },
});

const importOpen = ref(false);
const importRaw = ref('');
const importError = ref('');

function importJson() {
  importError.value = '';
  let items;
  try {
    items = JSON.parse(importRaw.value.trim() || '[]');
  } catch {
    importError.value = 'This is not valid JSON.';
    return;
  }
  const nodes = Array.isArray(items) ? nodesFromLegacyJson(items) : [];
  if (!nodes.length) {
    importError.value = 'No text or quote blocks found.';
    return;
  }
  props.editor.chain().focus().insertContent(nodes).run();
  importRaw.value = '';
  importOpen.value = false;
}
</script>
